import {
	Box,
	Divider,
	Typography,
	List,
	ListItem,
	ListItemText,
	Grid,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SaveIcon from "@mui/icons-material/Save";
import PublishIcon from "@mui/icons-material/Publish";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import {
	cloneCustomerGroup,
	resetAllStates,
	saveCustomerGroup,
	submitCustomerGroup,
	uploadFileForCustomerGroup,
	setCGState,
} from "../customerGroupSetupSlice";
import dayjs from "dayjs";
import { useState } from "react";
import { useEffect } from "react";
import CollapseSection from "../../../../components/ui/CollapseSection";
import CustomButton from "../../../../components/ui/CustomButton";

export default function Summary() {
	const autherization = localStorage.getItem("data");
	const data = JSON.parse(autherization);
	let setAccess = true;
	if (data?.restrictedAccess === 0) setAccess = true;
	else setAccess = false;

	const isRestrictedAccess = setAccess;
	const dispatch = useDispatch();
	const cgState = useSelector((store) => store.customerGroupSetup);
	const {
		editCGName,
		editFromDate,
		editToDate,
		selCustomers,
		countryID,
		editComments,
		// createEditStartEndDateModalOpened,
		customerTypeCode,
		customerLevelID,
		customerGroupDetail,
		files,
		country,
	} = cgState;

	const [hideCloneButton, setHideCloneButton] = useState(true);

	useEffect(() => {
		toggleVisibilityOfCloneButton();
	}, [customerGroupDetail,editCGName]);



	function toggleVisibilityOfCloneButton() {
		if (customerGroupDetail && customerGroupDetail.status === "Approved" && !editCGName.includes(".old")) {
			setHideCloneButton(false);
		} else {
			setHideCloneButton(true);
		}
	}

	function getDateFromDayjsDate(date, exactTime) {
		//console.log("CGCreate_getDateFromDayjsDate_InputDate", date);
		let outputDate = null;
		if (date && date instanceof dayjs) {
			const year = date.year();
			const month = date.month() + 1;
			const day = date.date();
			const time = new Date();

			if (exactTime) {
				const formattedTime = time.toLocaleTimeString("en-US", {
					hour12: false,
					hour: "2-digit",
					minute: "2-digit",
					second: "2-digit",
				});
				outputDate = `${year}-${month < 10 ? "0" + month : month}-${
					day < 10 ? "0" + day : day
				}T${formattedTime}`;
			} else {
				outputDate = `${year}-${month < 10 ? "0" + month : month}-${
					day < 10 ? "0" + day : day
				}T00:00:00`;
			}
		} else if (date && typeof date === "string") {
			outputDate = date;
		}
		//console.log("CGCreate_getDateFromDayjsDate_OutputDate", outputDate);
		return outputDate;
	}

	function formatCustomersDate() {
		const updatedCustomers = selCustomers.map((item) => {
		  let formattedStartDate = item.effectiveStartDate
			  ? dayjs(item.effectiveStartDate).format("YYYY-MM-DDTHH:mm:ss")
			  : dayjs(editFromDate).format("YYYY-MM-DDTHH:mm:ss");
	
		  let formattedEndDate = item.effectiveEndDate
			  ? dayjs(item.effectiveEndDate).format("YYYY-MM-DDTHH:mm:ss")
			  : dayjs(editToDate).format("YYYY-MM-DDTHH:mm:ss");
	
		  return {
			  ...item,
			  effectiveStartDate: formattedStartDate,
			  effectiveEndDate: formattedEndDate,
		  };
	  });
	
	  dispatch(setCGState("selCustomers", updatedCustomers));
	
	
		const customerList = updatedCustomers.map((item) => ({
			...item,
			effectiveStartDate: getDateFromDayjsDate(item.effectiveStartDate, false),
			effectiveEndDate: getDateFromDayjsDate(item.effectiveEndDate, false),
		}));
	
		return customerList;
	}

	function getCustomerGroupFiles() {
		const groupFiles = files.map((item) => {
			return {
				customerGroupFileID: item.customerGroupFileID
					? item.customerGroupFileID
					: 0,
				customerGroupID: item.customerGroupID ? item.customerGroupID : 0,
				filePath: item.name ? item.name : item.filePath,
				fileType: item.type ? item.type : item.fileType,
			};
		});
		return groupFiles;
	}

	function getFilePaths() {
		let filePaths = [];
		files.forEach((file, index) => {
			if (file instanceof File === false) {
				filePaths.push(file.filePath ? file.filePath : file.name);
			}
		});
		return filePaths;
	}

	function showPopup(message, severity) {
		dispatch(setCGState("popUpMsg", message));
		dispatch(setCGState("popUpSeverity", severity));
		dispatch(setCGState("popUpOpen", true));
	}

	const submitCG = async () => {
		if (editCGName.length <= 0) {
			showPopup("The customer group name cannot be empty ", "error");
			return;
		}
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const createdCG = {
				customerlist: formatCustomersDate(),
				customerGroupFiles: getCustomerGroupFiles(),
				selectedCustomerID: [],
				FilePaths: getFilePaths(),
				countryID,
				customerGroupName: editCGName,
				comments: editComments,
				updatedBy: data.email,
				email: data.email,
				effectiveStartDate: getDateFromDayjsDate(editFromDate, false),
				effectiveEndDate: getDateFromDayjsDate(editToDate, false),
				updatedDate: dayjs().toISOString(),
				customerGroupTypeCode: customerTypeCode,
				customerGroupLevelCode: customerLevelID,
				customerGroupID: customerGroupDetail.customerGroupID,
				sentToSAP: "N",
				status: "Submitted",
				previousGroupID: 0,
				sapGrpCode: "",
				activeInScenarios: 0,
			};
			const fileData = new FormData();
			files.forEach((file, index) => {
				if (file instanceof File) {
					fileData.append("files", file);
				}
			});
			dispatch(uploadFileForCustomerGroup(fileData));

			const response = await dispatch(submitCustomerGroup(createdCG)).unwrap();

			if (typeof response === "object") {
				dispatch(resetAllStates({ edit: true }));
				showPopup("Customer group submitted successfully", "success");
			} else {
				showPopup(response, "error");
			}
		} catch (error) {
			console.error("Error submitting customer group:", error);
			showPopup("There is some error in submitting customer group", "error");
		}
	};

	const saveCG = async () => {
		if (editCGName.length <= 0) {
			showPopup("The customer group name cannot be empty ", "error");
			return;
		}
		try {
			const data = JSON.parse(localStorage.getItem("data"));
			const createdCG = {
				customerlist: formatCustomersDate(),
				customerGroupFiles: getCustomerGroupFiles(),
				selectedCustomerID: [],
				FilePaths: getFilePaths(),
				countryID,
				customerGroupName: editCGName,
				comments: editComments,
				updatedBy: data.email,
				email: data.email,
				effectiveStartDate: getDateFromDayjsDate(editFromDate, false),
				effectiveEndDate: getDateFromDayjsDate(editToDate, false),
				updatedDate: dayjs().toISOString(),
				customerGroupTypeCode: customerTypeCode,
				customerGroupLevelCode: customerLevelID,
				customerGroupID: customerGroupDetail.customerGroupID,
				sentToSAP: "N",
				status: "Draft",
				previousGroupID: 0,
				sapGrpCode: "",
				activeInScenarios: 0,
			};

			const fileData = new FormData();
			files.forEach((file, index) => {
				if (file instanceof File) {
					fileData.append("files", file);
				}
			});
			dispatch(uploadFileForCustomerGroup(fileData));

			const response = await dispatch(saveCustomerGroup(createdCG)).unwrap();

			if (typeof response === "object") {
				dispatch(resetAllStates({ edit: true }));
				showPopup("Customer group saved successfully", "success");
			} else {
				showPopup(response, "error");
			}
		} catch (error) {
			console.error("Error saving customer group:", error);
			showPopup("There is some error in saving customer group", "error");
		}
	};

	function cloneCG() {
		if (editCGName.length <= 0) {
			showPopup("The customer group name cannot be empty ", "error");
			return;
		}
		const data = JSON.parse(localStorage.getItem("data"));
		// countryID
		// countryCode
		// filePaths
		// files
		// tranOptions
		const createdCG = {
			customerlist: formatCustomersDate(),
			customerGroupFiles: getCustomerGroupFiles(),
			selectedCustomerID: [],
			FilePaths: getFilePaths(),
			countryID,
			customerGroupName: editCGName,
			comments: editComments,
			updatedBy: data.email,
			email: data.email,
			effectiveStartDate: getDateFromDayjsDate(editFromDate, false),
			effectiveEndDate: getDateFromDayjsDate(editToDate, false),
			updatedDate: dayjs().toISOString(),
			customerGroupTypeCode: customerTypeCode,
			customerGroupLevelCode: customerLevelID,
			customerGroupID: customerGroupDetail.customerGroupID,
			sentToSAP: "N",
			status: "Draft",
			previousGroupID: 0,
			sapGrpCode: "",
			activeInScenarios: 0,
		};

		const fileData = new FormData();
		files.forEach((file, index) => {
			if (file instanceof File) {
				fileData.append("files", file);
			}
		});
		dispatch(uploadFileForCustomerGroup(fileData));

		//console.log(createdCG);
		dispatch(cloneCustomerGroup(createdCG));
		dispatch(resetAllStates({ edit: true }));
	}

	return (
		<Box sx={{ mt: 6 }}>
			{/* <Typography
            sx={{ fontWeight: "bold", color: "blue.main" }}
            gutterBottom
         >
            Summary
         </Typography> */}
			{/* <Box sx={{ mt: 3, display: "flex", flexDirection: "row" }} >
				<Typography sx={{ fontWeight: "bold", color: "blue.main", width: "100%", }} 
				className="compHeading"
				>
					Summary
				</Typography>
			</Box> */}
			<CollapseSection title="Summary">
				<Grid container spacing={1} sx={{ mb: 1, mt: 1 }}>
					<Grid item>
						<Typography sx={{ fontWeight: "bold" }}>
							Customer Group Name:
						</Typography>
					</Grid>
					<Grid item>
						<Typography>{editCGName}</Typography>
					</Grid>
				</Grid>

				<Grid container spacing={1} style={{ marginBottom: "5px" }}>
					<Grid item>
						<Typography sx={{ fontWeight: "bold" }}>Country:</Typography>
					</Grid>
					<Grid item>
						<Typography>{country}</Typography>
					</Grid>
				</Grid>

				<Grid container spacing={1} style={{ marginBottom: "5px" }}>
					<Grid item>
						<Typography sx={{ fontWeight: "bold" }}>
							Validity Period:
						</Typography>
					</Grid>
					<Grid item>
						<Typography>
							{new Date(editFromDate)
								.toLocaleDateString("en-UK", {
									year: "numeric",
									month: "2-digit",
									day: "2-digit",
								})
								.replace(/\//g, "-")}{" "}
							<strong>to</strong>{" "}
							{new Date(editToDate)
								.toLocaleDateString("en-UK", {
									year: "numeric",
									month: "2-digit",
									day: "2-digit",
								})
								.replace(/\//g, "-")}
						</Typography>
					</Grid>
				</Grid>

				<Typography sx={{ fontWeight: "bold" }}>Customers:</Typography>
				<Box
					sx={{
						width: "100%",
						height: 130,
						border: 1,
						borderRadius: 1,
						overflow: "auto",
						borderColor: "#c6c6c6",
						marginBottom: "10px",
					}}
				>
					<List>
						{selCustomers.map((item, index) => {
							return (
								<ListItem key={index}>
									<ListItemText>{item.customerName}</ListItemText>
								</ListItem>
							);
						})}
					</List>
				</Box>
			</CollapseSection>
			<Divider sx={{ mt: 4 }} />
			<Box
				sx={{
					display: "flex",
					flexDirection: "row",
					justifyContent: "flex-end",
					mt: 2,
				}}
			>
				<CustomButton
					startIcon={<SaveIcon />}
					disabled={!isRestrictedAccess}
					sx={{
						mt: 1,
						mr: 2,
					}}
					onClick={saveCG}
				>
					Save
				</CustomButton>

				<CustomButton
					startIcon={<PublishIcon />}
					disabled={!isRestrictedAccess}
					sx={{
						mt: 1,
						mr: 2,
					}}
					onClick={submitCG}
				>
					Submit
				</CustomButton>
				
				{!hideCloneButton && (
					<CustomButton
					startIcon={<ContentCopyIcon />}
					disabled={!isRestrictedAccess}
					sx={{
						//display: hideCloneButton ? "none" : "block",
						mt: 1,
					}}
					onClick={cloneCG}
				>
					Clone
				</CustomButton>
				)}
			
			</Box>
		</Box>
	);
}
